import { BaseAction } from './index'

import { CampaignsActions } from './campaigns'

export enum STATE_KEYS {
    Login = 'login',
    Logout = 'logout',
    ResetPassword = 'resetPassword',
    UpdatePassword = 'updatePassword',
    Profile = 'profile',
    Constants = 'constants',
    Campaign = 'campaign',
    CampaignSummary = 'campaignSummary',
    CampaignPerformance = 'campaignPerformance',
    CampaignProgress = 'campaignProgress',
    CampaignsList = 'campaignsList',
    BlockedCampaignCheck = 'blockedCampaignCheck',
    SubmissionsSummary = 'submissionsSummary',
    BrandsList = 'brandsList',
    CreateBrand = 'createBrand',
    UpdateBrand = 'updateBrand',
    DeleteBrand = 'deleteBrand',
    RegisterCampaign = 'registerCampaign',
    UpdateCampaign = 'updateCampaign',
    SubmitCampaign = 'SubmitCampaign',
    PublishCampaign = 'publishCampaign',
    SendCampaignToEdit = 'sendCampaignToEdit',
    SendCampaignToPaymentRequest = 'sendCampaignToPaymentRequest',
    SendCampaignBackToReview = 'sendCampaignBackToReview',
    DuplicateCampaign = 'DuplicateCampaign',
    SetCampaignSubmissionStatus = 'setCampaignSubmissionStatus',
    SetAutoSubmissionStatus = 'setAutoSubmissionStatus',
    CloseCampaign = 'closeCampaign',
    SubmissionsList = 'submissionsList',
    DropoutsList = 'dropoutsList',
    RejectedList = 'rejectedList',
    RejectSubmission = 'rejectSubmission',
    ApproveSubmission = 'approveSubmission',
    UpdateCompletedSchedule = 'updateCompletedSchedule',
    GetDiscussSubmission = 'getDiscussSubmission',
    CreateDiscussSubmission = 'createDiscussSubmission',
    UpdateDiscussSubmission = 'updateDiscussSubmission',
    DeleteDiscussSubmission = 'deleteDiscussSubmission',
    VoteSubmission = 'voteSubmission',
    RequestEditsForSubmission = 'requestEditsForSubmission',
    ReviewPendingAction = 'reviewPendingAction',
    UpdateSubmissionPerformance = 'updateSubmissionPerformance',
    PaySubmission = 'paySubmission',
    RejectSubmissionPayout = 'rejectSubmissionPayout',
    TasksList = 'tasksList',
    RegisterTask = 'registerTask',
    UpdateTask = 'updateTask',
    DeleteTask = 'deleteTask',
    MassSubmission = 'massSubmission',
    MassRegistration = 'massRegistration',
    MassApproveRegistrationByUsername = 'MassApproveRegistrationByUsername',
    TeamsList = 'teamsList',
    GetTeam = 'getTeam',
    CreateTeam = 'createTeam',
    UpdateTeam = 'updateTeam',
    UpdateTeamType = 'updateTeamType',
    DeleteTeam = 'deleteTeam',
    TeamMembersList = 'teamMembersList',
    TeamBrandsList = 'teamBrandsList',
    GetBrand = 'getBrand',
    CreateMember = 'createMember',
    UpdateMember = 'updateMember',
    DeleteMember = 'deleteMember',
    ResendMemberInvite = 'resendMemberInvite',
    GetPartiposterTagHistoryList = 'GetPartiposterTagHistoryList',
    GetPartiposterTagAddList = 'GetPartiposterTagAddList',
    SavePartiposterTag = 'SavePartiposterTag',
    UpdatePartiposterTag = 'UpdatePartiposterTag',
    DeletePartiposterTag = 'DeletePartiposterTag',
    GetLocationOptions = 'GetLocationOptions',
    GetProfileOptions = 'GetProfileOptions',
    GetRegistrationForm = 'GetRegistrationForm',
    CreateRegistrationForm = 'CreateRegistrationForm',
    UpdateRegistrationForm = 'UpdateRegistrationForm',
    UpdateRegistrationMarkAsViewed = 'UpdateRegistrationMarkAsViewed',
    ExportProgress = 'ExportProgress',
    ExportPerformance = 'ExportPerformance',
    ExportOverview = 'ExportOverview',
    RegistrationResultsList = 'RegistrationResultsList',
    ExportRegistrationResults = 'ExportRegistrationResults',
    ExportSubmissions = 'ExportSubmissions',
    SavePriorityListOrdering = 'SavePriorityListOrdering',
    UpdateWaitlistOrderMode = 'UpdateWaitlistOrderMode',
    UpdateRegistrationMaxSlots = 'UpdateRegistrationMaxSlots',
    GetBannerGroups = 'GetBannerGroups',
    GetBanners = 'GetBanners',
    DisableBanner = 'DisableBanner',
    CreateBanner = 'CreateBanner',
    AddRole = 'addRole',
    GetRoles = 'getRoles',
    EditRole = 'editRole',
    DeleteRole = 'deleteRole',
    GetPermissions = 'getPermissions',
    UpdateRolesPermissions = 'updateRolesPermissions',
    GetEditRequestHistoryList = 'GetEditRequestHistoryList',
    SkipLoading = 'SkipLoading',
    UpdateTasksOrdering = 'UpdateTasksOrdering',
    HighlightRegistration = 'HighlightRegistration',
    UpdateCampaignType = 'UpdateCampaignType',
    GetCampaignComments = 'GetCampaignComments',
    AddCampaignComment = 'AddCampaignComment',
    ReplyCampaignComment = 'ReplyCampaignComment',
    UpdateCampaignComment = 'UpdateCampaignComment',
    AddCustomTag = 'AddCustomTag',
    GetTags = 'GetTags',
    DeleteCampaignComment = 'DeleteCampaignComment',
    ResolveCampaignThread = 'ResolveCampaignThread',
    VerifyToken = 'VerifyToken',
    GetCampaignTemplates = 'GetCampaignTemplates',
    CreateCampaignByTemplate = 'CreateCampaignByTemplate',
    UpdateTemplateData = 'UpdateTemplateData',
    VerifyEmail = 'VerifyEmail',
    SignUp = 'SignUp',
    SendInvite = 'SendInvite',
    SignUpDetails = 'SignUpDetails',
    InviteTeamMember = 'InviteTeamMember',
    DeleteCampaign = 'DeleteCampaign',
    GetTemplateDetail = 'GetTemplateDetail',
    GetTemplateData = 'GetTemplateData',
    SwitchTemplate = 'SwitchTemplate',
    GetCampaignInfo = 'GetCampaignInfo',
    GetCampaignSchedule = 'GetCampaignSchedule',
    GetCampaignTaskElements = 'GetCampaignTaskElements',
    UpdateCampaignInfo = 'UpdateCampaignInfo',
    UpdateCampaignSchedule = 'UpdateCampaignSchedule',
    UpdateCampaignTaskElements = 'UpdateCampaignTaskElements',
    SubmitCampaignTemplate = 'SubmitCampaignTemplate',
    UpdateTotalEarning = 'UpdateTotalEarning',
    PaidOutsideApp = 'PaidOutsideApp',
    GetPaymentSummary = 'GetPaymentSummary',
    UpdatePaymentSummary = 'UpdatePaymentSummary',
    TemplateSendToEdit = 'TemplateSendToEdit',
    TemplateRequestPayment = 'TemplateRequestPayment',
    TemplateSendToReview = 'TemplateSendToReview',
    TemplatePublish = 'TemplatePublish',
    ExportTemplate = 'ExportTemplate',
    ExtendFirstStepDeadline = 'ExtendFirstStepDeadline',
    UpdateBusinessDetails = 'UpdateBusinessDetails',
    GetBusinessDetails = 'GetBusinessDetails',
    SaveAdditionalPayment = 'SaveAdditionalPayment',
    UpdateServiceFee = 'UpdateServiceFee',
    UpdateTax = 'UpdateTax',
    GetCampaignOverview = 'GetCampaignOverview',
    GetCampaignPerformance = 'GetCampaignPerformance',
    GetTaskPerformance = 'GetTaskPerformance',
    GetIndividualPerformance = 'GetIndividualPerformance',
    GetIndividualPerformanceStats = 'GetIndividualPerformanceStats',
    GetTopPerformers = 'GetTopPerformers',
    UpdateAmbassadorFavorite = 'UpdateAmbassadorFavorite',
    GetIndividualPerformanceFilters = 'GetIndividualPerformanceFilters',
    AmbassadorBrands = 'AmbassadorBrands',
    BrandContentTypes = 'BrandContentTypes',
    AmbassadorFilters = 'AmbassadorFilters',
    AmbassadorList = 'AmbassadorList',
    ReviewCaption = 'ReviewCaption',
    DownloadCampaignReport = 'DownloadCampaignReport',
}

export type StateKey =
    | STATE_KEYS.Login
    | STATE_KEYS.Logout
    | STATE_KEYS.ResetPassword
    | STATE_KEYS.UpdatePassword
    | STATE_KEYS.Profile
    | STATE_KEYS.Constants
    | STATE_KEYS.Campaign
    | STATE_KEYS.CampaignSummary
    | STATE_KEYS.CampaignProgress
    | STATE_KEYS.CampaignPerformance
    | STATE_KEYS.CampaignsList
    | STATE_KEYS.BlockedCampaignCheck
    | STATE_KEYS.SubmissionsSummary
    | STATE_KEYS.BrandsList
    | STATE_KEYS.CreateBrand
    | STATE_KEYS.UpdateBrand
    | STATE_KEYS.DeleteBrand
    | STATE_KEYS.RegisterCampaign
    | STATE_KEYS.UpdateCampaign
    | STATE_KEYS.SubmitCampaign
    | STATE_KEYS.PublishCampaign
    | STATE_KEYS.SendCampaignToEdit
    | STATE_KEYS.SendCampaignToPaymentRequest
    | STATE_KEYS.SendCampaignBackToReview
    | STATE_KEYS.DuplicateCampaign
    | STATE_KEYS.SubmissionsList
    | STATE_KEYS.DropoutsList
    | STATE_KEYS.RejectedList
    | STATE_KEYS.RejectSubmission
    | STATE_KEYS.ApproveSubmission
    | STATE_KEYS.UpdateCompletedSchedule
    | STATE_KEYS.GetDiscussSubmission
    | STATE_KEYS.CreateDiscussSubmission
    | STATE_KEYS.UpdateDiscussSubmission
    | STATE_KEYS.DeleteDiscussSubmission
    | STATE_KEYS.VoteSubmission
    | STATE_KEYS.RequestEditsForSubmission
    | STATE_KEYS.ReviewPendingAction
    | STATE_KEYS.UpdateSubmissionPerformance
    | STATE_KEYS.PaySubmission
    | STATE_KEYS.RejectSubmissionPayout
    | STATE_KEYS.TasksList
    | STATE_KEYS.RegisterTask
    | STATE_KEYS.UpdateTask
    | STATE_KEYS.DeleteTask
    | STATE_KEYS.SetCampaignSubmissionStatus
    | STATE_KEYS.SetAutoSubmissionStatus
    | STATE_KEYS.CloseCampaign
    | STATE_KEYS.MassSubmission
    | STATE_KEYS.MassRegistration
    | STATE_KEYS.MassApproveRegistrationByUsername
    | STATE_KEYS.TeamsList
    | STATE_KEYS.GetTeam
    | STATE_KEYS.CreateTeam
    | STATE_KEYS.UpdateTeam
    | STATE_KEYS.UpdateTeamType
    | STATE_KEYS.DeleteTeam
    | STATE_KEYS.TeamMembersList
    | STATE_KEYS.TeamBrandsList
    | STATE_KEYS.GetBrand
    | STATE_KEYS.CreateMember
    | STATE_KEYS.UpdateMember
    | STATE_KEYS.DeleteMember
    | STATE_KEYS.ResendMemberInvite
    | STATE_KEYS.GetPartiposterTagHistoryList
    | STATE_KEYS.GetPartiposterTagAddList
    | STATE_KEYS.SavePartiposterTag
    | STATE_KEYS.UpdatePartiposterTag
    | STATE_KEYS.DeletePartiposterTag
    | STATE_KEYS.GetLocationOptions
    | STATE_KEYS.GetProfileOptions
    | STATE_KEYS.GetRegistrationForm
    | STATE_KEYS.CreateRegistrationForm
    | STATE_KEYS.UpdateRegistrationForm
    | STATE_KEYS.UpdateRegistrationMarkAsViewed
    | STATE_KEYS.ExportProgress
    | STATE_KEYS.ExportPerformance
    | STATE_KEYS.ExportOverview
    | STATE_KEYS.RegistrationResultsList
    | STATE_KEYS.ExportRegistrationResults
    | STATE_KEYS.ExportSubmissions
    | STATE_KEYS.SavePriorityListOrdering
    | STATE_KEYS.UpdateWaitlistOrderMode
    | STATE_KEYS.UpdateRegistrationMaxSlots
    | STATE_KEYS.GetBannerGroups
    | STATE_KEYS.GetBanners
    | STATE_KEYS.DisableBanner
    | STATE_KEYS.CreateBanner
    | STATE_KEYS.AddRole
    | STATE_KEYS.GetRoles
    | STATE_KEYS.EditRole
    | STATE_KEYS.DeleteRole
    | STATE_KEYS.GetPermissions
    | STATE_KEYS.UpdateRolesPermissions
    | STATE_KEYS.GetEditRequestHistoryList
    | STATE_KEYS.SkipLoading
    | STATE_KEYS.UpdateTasksOrdering
    | STATE_KEYS.HighlightRegistration
    | STATE_KEYS.UpdateCampaignType
    | STATE_KEYS.GetCampaignComments
    | STATE_KEYS.AddCampaignComment
    | STATE_KEYS.ReplyCampaignComment
    | STATE_KEYS.UpdateCampaignComment
    | STATE_KEYS.AddCustomTag
    | STATE_KEYS.GetTags
    | STATE_KEYS.DeleteCampaignComment
    | STATE_KEYS.ResolveCampaignThread
    | STATE_KEYS.VerifyToken
    | STATE_KEYS.GetCampaignTemplates
    | STATE_KEYS.CreateCampaignByTemplate
    | STATE_KEYS.UpdateTemplateData
    | STATE_KEYS.VerifyEmail
    | STATE_KEYS.SignUp
    | STATE_KEYS.SendInvite
    | STATE_KEYS.SignUpDetails
    | STATE_KEYS.InviteTeamMember
    | STATE_KEYS.DeleteCampaign
    | STATE_KEYS.GetTemplateDetail
    | STATE_KEYS.GetTemplateData
    | STATE_KEYS.SwitchTemplate
    | STATE_KEYS.GetCampaignInfo
    | STATE_KEYS.GetCampaignSchedule
    | STATE_KEYS.GetCampaignTaskElements
    | STATE_KEYS.UpdateCampaignInfo
    | STATE_KEYS.UpdateCampaignSchedule
    | STATE_KEYS.UpdateCampaignTaskElements
    | STATE_KEYS.SubmitCampaignTemplate
    | STATE_KEYS.UpdateTotalEarning
    | STATE_KEYS.PaidOutsideApp
    | STATE_KEYS.GetPaymentSummary
    | STATE_KEYS.UpdatePaymentSummary
    | STATE_KEYS.TemplateSendToEdit
    | STATE_KEYS.TemplateRequestPayment
    | STATE_KEYS.TemplateSendToReview
    | STATE_KEYS.TemplatePublish
    | STATE_KEYS.ExportTemplate
    | STATE_KEYS.ExtendFirstStepDeadline
    | STATE_KEYS.UpdateBusinessDetails
    | STATE_KEYS.GetBusinessDetails
    | STATE_KEYS.SaveAdditionalPayment
    | STATE_KEYS.UpdateServiceFee
    | STATE_KEYS.UpdateTax
    | STATE_KEYS.GetCampaignOverview
    | STATE_KEYS.GetCampaignPerformance
    | STATE_KEYS.GetTaskPerformance
    | STATE_KEYS.GetIndividualPerformance
    | STATE_KEYS.GetIndividualPerformanceStats
    | STATE_KEYS.GetTopPerformers
    | STATE_KEYS.UpdateAmbassadorFavorite
    | STATE_KEYS.GetIndividualPerformanceFilters
    | STATE_KEYS.UpdateAmbassadorFavorite
    | STATE_KEYS.AmbassadorBrands
    | STATE_KEYS.BrandContentTypes
    | STATE_KEYS.AmbassadorFilters
    | STATE_KEYS.AmbassadorList
    | STATE_KEYS.ReviewCaption
    | STATE_KEYS.DownloadCampaignReport

export enum PAGINATION_STATE_KEYS {
    CampaignsList = STATE_KEYS.CampaignsList,
    CampaignPerformance = STATE_KEYS.CampaignPerformance,
    CampaignProgress = STATE_KEYS.CampaignProgress,
    SubmissionsSummary = STATE_KEYS.SubmissionsSummary,
    SubmissionsList = STATE_KEYS.SubmissionsList,
    DropoutsList = STATE_KEYS.DropoutsList,
    RejectedList = STATE_KEYS.RejectedList,
    BrandsList = STATE_KEYS.BrandsList,
    TeamsList = STATE_KEYS.TeamsList,
    TeamMembersList = STATE_KEYS.TeamMembersList,
    TeamBrandsList = STATE_KEYS.TeamBrandsList,
    RegistrationResultsList = STATE_KEYS.RegistrationResultsList,
    BannerGroups = STATE_KEYS.GetBannerGroups,
    Banners = STATE_KEYS.GetBanners,
    CampaignTemplates = STATE_KEYS.GetCampaignTemplates,
    IndividualPerformance = STATE_KEYS.GetIndividualPerformance,
    Ambassador = STATE_KEYS.AmbassadorList,
}

export type PaginationStateKey =
    | STATE_KEYS.CampaignsList
    | STATE_KEYS.CampaignProgress
    | STATE_KEYS.CampaignPerformance
    | STATE_KEYS.SubmissionsSummary
    | STATE_KEYS.SubmissionsList
    | STATE_KEYS.DropoutsList
    | STATE_KEYS.RejectedList
    | STATE_KEYS.BrandsList
    | STATE_KEYS.TeamsList
    | STATE_KEYS.TeamMembersList
    | STATE_KEYS.TeamBrandsList
    | STATE_KEYS.RegistrationResultsList
    | STATE_KEYS.GetBannerGroups
    | STATE_KEYS.GetBanners
    | STATE_KEYS.GetCampaignTemplates
    | STATE_KEYS.GetIndividualPerformance
    | STATE_KEYS.GetTopPerformers
    | STATE_KEYS.AmbassadorList
export type RequestsState = {
    isLoading: Partial<Record<STATE_KEYS, boolean>>
    isSuccess: { [stateKey in StateKey]?: boolean }
    responses: { [stateKey in StateKey]?: boolean }
    pagination: {
        [stateKey in PaginationStateKey]?: {
            count: number
            next: string | null
            previous: string | null
        }
    }
}

const initialState: RequestsState = {
    isLoading: { [STATE_KEYS.Profile]: true },
    isSuccess: {},
    responses: {},
    pagination: {},
}

enum RequestsAction {
    SET_LOADING = 'requests/SET_LOADING',
    SET_SUCCESS = 'requests/SET_SUCCESS',
    SET_RESPONSE = 'requests/SET_RESPONSE',
    CLEAR_RESPONSE = 'requests/CLEAR_RESPONSE',
    SET_PAGINATION = 'requests/SET_PAGINATION',
    UNDO = 'requests/UNDO',
    SKIPUNDO = 'requests/SKIPUNDO',
}

interface BasePayload {
    stateKey: StateKey
}

interface SetLoadingPayload extends BasePayload {
    isLoading: boolean
}

export const setLoading = (payload: SetLoadingPayload) => ({
    payload,
    type: RequestsAction.SET_LOADING,
})

interface SetSuccessPayload extends BasePayload {
    isSuccess: boolean
}

export const setSuccess = (payload: SetSuccessPayload) => ({
    payload,
    type: RequestsAction.SET_SUCCESS,
})

interface SetResponsePayload extends BasePayload {
    response: any
}

export const setResponse = (payload: SetResponsePayload) => ({
    payload,
    type: RequestsAction.SET_RESPONSE,
})

type ClearResponsePayload = BasePayload

export const clearResponse = (payload: ClearResponsePayload) => ({
    payload,
    type: RequestsAction.CLEAR_RESPONSE,
})

interface SetPaginationPayload extends BasePayload {
    count: number | null
    next: string | ''
    previous: string | ''
}

export const setPagination = (payload: SetPaginationPayload) => ({
    payload,
    type: RequestsAction.SET_PAGINATION,
})

interface UndoPayload {
    undoId: string
}

export const undo = (payload: UndoPayload) => ({
    payload,
    type: RequestsAction.UNDO,
})

export const skipUndo = (payload: UndoPayload) => ({
    payload,
    type: RequestsAction.SKIPUNDO,
})

export const requestsReducer = (state: RequestsState = initialState, action: BaseAction) => {
    switch (action.type) {
        case RequestsAction.SET_LOADING: {
            const { stateKey, isLoading } = action.payload as SetLoadingPayload
            return Object.assign({}, state, { isLoading: { ...state.isLoading, [stateKey]: isLoading } })
        }
        case RequestsAction.SET_SUCCESS: {
            const { stateKey, isSuccess } = action.payload as SetSuccessPayload
            return Object.assign({}, state, { isSuccess: { ...state.isSuccess, [stateKey]: isSuccess } })
        }
        case RequestsAction.SET_RESPONSE: {
            const { stateKey, response } = action.payload as SetResponsePayload
            return Object.assign({}, state, { responses: { ...state.responses, [stateKey]: response } })
        }
        case RequestsAction.CLEAR_RESPONSE: {
            const { stateKey } = action.payload as ClearResponsePayload
            const { [stateKey]: toClear, ...responses } = state.responses
            return Object.assign({}, state, { responses })
        }
        case RequestsAction.SET_PAGINATION: {
            const { stateKey, count, next, previous } = action.payload as SetPaginationPayload
            return Object.assign({}, state, {
                pagination: { ...state.pagination, [stateKey]: { count, next, previous } },
            })
        }
        case CampaignsActions.CAMPAIGN_LIST_CLEAR: {
            return Object.assign({}, state, {
                pagination: {
                    ...state.pagination,
                    [STATE_KEYS.CampaignsList]: {},
                },
            })
        }
        default:
            return state
    }
}

export const createGetErrors = (stateKeys: StateKey[]) => (state: RequestsState) => {
    return stateKeys.reduce((memo: any, stateKey: StateKey) => {
        memo[stateKey] = state.responses[stateKey]
        return memo
    }, {})
}

export const createGetLoading = (stateKeys: StateKey[]) => (state: RequestsState) => {
    return stateKeys.some(stateKey => state.isLoading[stateKey] === true)
}

export const selectIsLoading = (state: RequestsState, stateKeys: StateKey[]) =>
    stateKeys.some(stateKey => state.isLoading[stateKey] === true)

export interface Pagination extends SetPaginationPayload {
    hasMore: boolean
}

export const createGetPagination = (stateKey: PaginationStateKey) => (state: RequestsState) => {
    const pagination = state.pagination[stateKey] || { count: null, next: '', previous: '' }
    return {
        ...pagination,
        hasMore: pagination.count !== null && pagination.next !== null,
    }
}
